import React, { Component } from 'react';
import '../App.css';
import TemplateListItem from '../components/TemplateListItem'
import { withRouter } from 'react-router-dom'
import { deleteJson, getJson } from '../helpers/RequestsHelper';
import { withTranslation } from 'react-i18next';
import FilterSelector from '../components/FilterSelector';

import { supportedRoles, supportedIndustries } from '../helpers/constants'

import SelectObject from './WorkflowComponents/Inputs/SelectObject'
import { publicApps, underCertificationApps } from '../helpers/applications'


class AllFlowsPage extends Component {


    state = {
        loading: true,
        selectedApp: undefined,
        selectedToApps: [],
        selectedRoles: [],
        selectedIndustries: [],
        items: []
    }

    constructor(props) {
        super(props)
        this.onSelect = this.onSelect.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.onApplicationSelect = this.onApplicationSelect.bind(this)
        this.onRoleSelect = this.onRoleSelect.bind(this)
        this.onIndustrySelect = this.onIndustrySelect.bind(this)
        this.onClearFilters = this.onClearFilters.bind(this)
    }

    componentDidMount() {
        const { t } = this.props;
        document.title = t("titleappname") + t("title_templates")
        this.fillFlows();
    }

    async fillFlows() {
        let url = process.env.REACT_APP_SERVER_BASE_URL + "/templates";
        url += "?role=" + this.state.selectedRoles.join(",")
        url += "&industry=" + this.state.selectedIndustries.join(",")
        if (this.state.selectedApp) {
            url += "&apps=" + this.state.selectedApp.id
        }
        const items = await getJson(url);
        if (items.error === "fail") {
            return
        }

        const sortedItems = items.sort(function (a, b) {
            //Show first the implemented
            if (a.comingsoon && !b.comingsoon) {
                return 1
            }
            if (b.comingsoon && !a.comingsoon) {
                return -1
            }

            //If both are comming soon we check the vote number
            if (a.comingsoon && b.comingsoon) {
                return b.votes - a.votes
            }

            //The rest are sorted by title 
            return a.title.localeCompare(b.title)
        });

        this.setState(({ items: sortedItems, loading: false }));
    }

    render() {

        const { t } = this.props;

        let templates = []
        let comingsoon = []
        let userTemplates = []
        this.state.items.forEach(template => {
            if (template.user) {
                userTemplates.push(
                    <TemplateListItem template={template} key={template._id} onClick={this.onSelect} onDelete={this.onDelete} />
                )
            }
            else if (template.comingsoon) {
                comingsoon.push(
                    <TemplateListItem template={template} key={template._id} removehand={true} />
                )
            } else {
                templates.push(
                    <TemplateListItem template={template} key={template._id} onClick={this.onSelect} />
                )
            }
        })

        return (
            <div className="list-group">
                <h3>{t("titlefindworkflow")}</h3>
                <h5>{t("descfindworkflow")}</h5>
                <div className="d-flex row" >
                    <div className="p-2" style={{width: window.innerWidth > 993? '300px' : '100%' }}>
                        <SelectObject
                            // groups={[
                            //     { name: "Applications", items: publicApps },
                            //     { name: "Awaiting Certification", items: underCertificationApps }
                            // ]}
                            id="application"
                            items={publicApps}
                            fieldName="name"
                            title={t("lbl_select_application")}
                            placeholder={t("lbl_placeholder_application")}
                            onSelect={this.onApplicationSelect}
                            selected={this.state.selectedApp} />
                    </div>
                    <div className="p-2" style={{width: window.innerWidth > 993? '300px' : '100%' }}>
                        <FilterSelector items={supportedRoles} title={t("lblrole")} onSelect={this.onRoleSelect} selected={this.state.selectedRoles} />
                    </div>
                    <div className="p-2" style={{width: window.innerWidth > 993? '300px' : '100%' }}>
                        <FilterSelector items={supportedIndustries} title={t("lblindustry")} onSelect={this.onIndustrySelect} selected={this.state.selectedIndustries} />
                    </div>
                    <div className="p-2">
                        <br />
                        <div className="form-control-wrap">
                            <button className="submit-btn-2" style={{ padding: "8px" }} onClick={this.onClearFilters}>{t("btnclear")}</button>
                        </div>
                    </div>
                </div>
                <br />
                {this.state.loading ?
                    <div className="spinner-border" role="status">
                        <span className="sr-only">{t("loading")}</span>
                    </div>
                    : <>
                        {userTemplates.length > 0 ?
                            <>
                                <br />
                                <h4>My Templates</h4>
                                <div className="d-flex flex-wrap" style={{justifyContent: this.props.isLegacy? '' : 'center'}}>
                                    {userTemplates}
                                </div>
                            </>
                            : ""}
                        {templates.length > 0 ?
                            <>
                                <br />
                                <h4>Templates</h4>
                                <div className="d-flex flex-wrap" style={{justifyContent: this.props.isLegacy? '' : 'center'}}>
                                    {templates}
                                </div>
                            </>
                            : ""}
                        {comingsoon.length > 0 ?
                            <>
                                <br />
                                <h4>Coming Soon</h4>
                                <div className="d-flex flex-wrap" style={{justifyContent: this.props.isLegacy? '' : 'center'}}>
                                    {comingsoon}
                                </div>
                            </>
                            : ""}

                    </>
                }
            </div>
        )
    }

    onSelect(template) {
        this.props.history.push("/workflow/template/" + template._id);
    }

    async onDelete(templateId) {
        await deleteJson(process.env.REACT_APP_SERVER_BASE_URL + "/templates/" + templateId);
        this.setState({ items: this.state.items.filter(a => a._id !== templateId) })
    }

    onApplicationSelect(selectedApp) {
        this.setState({ selectedApp, loading: true }, () => this.fillFlows());
    }

    onRoleSelect(ids) {
        this.setState({ selectedRoles: ids, loading: true }, () => this.fillFlows());
    }

    onIndustrySelect(ids) {
        this.setState({ selectedIndustries: ids, loading: true }, () => this.fillFlows());
    }

    onClearFilters() {
        this.setState({ selectedApp: "", selectedRoles: [], selectedIndustries: [] }, () => this.fillFlows());
    }
}
export default withRouter(withTranslation()(AllFlowsPage), AllFlowsPage);